import { render, staticRenderFns } from "./inActiveCompanies.vue?vue&type=template&id=55bfa31f"
import script from "./inActiveCompanies.vue?vue&type=script&lang=js"
export * from "./inActiveCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports